<template>
  <div>
    <div class="tabbar">
      <van-tabbar v-model="active" :active-color="variables.theme" :fixed="false" route>
        <van-tabbar-item to="/" icon="wap-home">首页</van-tabbar-item>
        <van-tabbar-item to="/info" v-if="this.$store.getters.count<1" icon="bars">消息</van-tabbar-item>
        <van-tabbar-item to="/info" v-else icon="bars" :badge="this.$store.getters.count">消息</van-tabbar-item>
        <!--<van-tabbar-item to="/cart" icon="shopping-cart">购物车</van-tabbar-item>-->
        <van-tabbar-item to="/user" icon="manager">我的</van-tabbar-item>
      </van-tabbar>
    </div>
    <div class="tabbar--placeholder" style="width:100%;height:50px;background-color: #F2F2F2" />
  </div>
</template>

<script>
import variables from '@/styles/variables.scss'
import store from '../../store'
import { count } from '../../api/notice'
export default {
  data() {
    return {
      active: 0
    }
  },
  created() {
    count().then((response)=>{
      console.log("response.tttwwwwvvvvawa",response.result)
      store.dispatch('other/setNoticeCount',response.result)
      console.log("response.tttwwwwvvvva333",store.getters.count)
    })
  },
  computed: {
    variables() {
      return variables
    }
  }
}
</script>

<style lang="scss" scoped>
.tabbar {
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  border-top: 2px solid #f5f5f5;
}
</style>
